export default __webpack_public_path__ + "static/media/active_project_ico.3a10243d.svg";